import React, { Component } from 'react';
import { Layout, Carousel, Tabs, Icon, Card, Row, Col } from 'antd';
import { Route, Link } from 'react-router-dom';
import { FormattedMessage, FormattedHTMLMessage,   injectIntl } from 'react-intl';
import getCookie from '../cookie/getCookie';
import { Parse } from 'parse';
import updateInstallation from '../installation';

import Header from './Header';
import FeaturedSticker from '../components/FeaturedSticker';

const { Content, Footer } = Layout;
const TabPane = Tabs.TabPane;

class Home extends Component{

  constructor(props){
    super(props);
    this.state = {
      popularList:[],
      risingList:[]
    };
  }
 
  componentDidMount() {

    getFeaturedStickers('popular')
    .then(async popularList => {
      const risingList = await getFeaturedStickers('rising');
      this.setState({popularList, risingList});
    })
    .catch(err => console.log(err));


    //cookie 추가
    const currentUser = getCookie('currentUser');
  
    if (currentUser) {
      const key = 'Parse/' + process.env.REACT_APP_APP_ID + '/currentUser';
      sessionStorage.setItem(key, currentUser);
    }

    if (getCookie('popup_addSNSLink') !== 'done'){
      window.open(`/event/addsnslink${this.props.intl ? '?lang=' + this.props.intl.locale : ''}`,'popup_addSNSLink','location=no,toolbar=no,menubar=no,scrollbars=yes,resizable=yes,innerWidth=438,innerHeight=375,left=20,top=100');
    }

      //event popup check
      new Parse.Query(Parse.Object.extend('WebService'))
      .equalTo('url','stickerfarm.contest.popup')
      .equalTo('available', true)
      .first({
        success:(result)=>{
            // const doubleParam=`scrollbars=no,resizable=no,status=no,location=no,toolbar=no,menubar=no,width=400,height=420,left=10,top=150`;
            // if ( getCookie( "openDouble" ) !== "done" && result )
            //   window.open( "/event/double","popup_double", doubleParam);
            // if ( getCookie( "openSignUp" ) !== "done" && result)
            //   window.open("/event/signup","popup_signup","width=400,height=660,left=410,top=150")
            if (getCookie('studioContestPopup') !== 'done' && result){
              window.open('/event/studiocontest','popup_studiocontest','width=500,height=800,left=20,top=100');
            }
        },
        error:(error)=>{
          if (error.code === 209 && error.message === 'invalid session token') {
              Parse.User.logOut()
              .then(()=>{
                console.log('user : ' + Parse.User.current());
                updateInstallation({
                  user : Parse.User.current()
                });
                this.props.logoutSuccess();
              })
              .catch((logoutError)=>{
                this.props.logoutFailed(logoutError);
              });
          }
        }
      });
  }
  render(){
      return (
        <Layout className="layout">
          <Route component={Header}/>
          <Content style={{backgroundColor:'#f9f9f9'}}>
            <div className="main-background">
              <div className="main-banner">
                <p className="main-banner-explain">
                  <FormattedHTMLMessage
                    id={'Home.mainBanner.explain'}
                    defaultMessage={'Selling even only 1 sticker is possible<br/>Go global with mojitok!'}
                  />
                </p>
              </div>
            </div>
            {/* stickerfarm introduction start */}
            <div className="main-introduction">
              <img src={require('../img/home/logo_mojitok_stickerfarm_gray.svg').default} alt="mojitok x stickerfarm"/>
              <p className="main-introduction-text">
                <FormattedHTMLMessage
                  id={'Home.introduction.mojitokXstickerfarm'}
                  defaultMessage={'It’s a sticker platform which provides the stickers to more than a trillion users worldwide<br/>through Samsung Galaxy series, Apple iMessage, Zalo and so on.'}
                />
              </p>
            </div>
            {/*stickerfarm introduction end */}
            {/* join us if you are start */}
            <p className="main-subtitle">Join us if you are</p>
            <div className="main-block-wapper">
              <Row gutter={16} style={{width:1040, marginBottom: 80}}>
              {
                ['process', 'worldwide', 'data'].map((value, idx) =>
                  <Col span={8} key={idx}>
                    <Card className="main-joinus-card">
                      <img src={require(`../img/home/joinus_img_0${idx + 1}_${value}.svg`).default} alt={value}/>
                      <p className="main-joinus-title"><FormattedMessage id={`Home.joinUs.title.0${idx + 1}`}/></p>
                      <p className="main-joinus-subtitle"><FormattedHTMLMessage id={`Home.joinUs.subtitle.0${idx + 1}`}/></p>
                      <p className="main-joinus-description"><FormattedHTMLMessage id={`Home.joinUs.description.0${idx + 1}`}/></p>
                    </Card>
                  </Col>
                )
              }
              </Row>
            </div>
            {/*join us if you are end */}

          { /* how to user start */ }
            <div style={{minWidth:1200, backgroundColor:'#ffffff', paddingBottom:13}}>
              <p className="main-subtitle">
                <FormattedMessage
                  id={'Home.howToUse.title'}
                  defaultMessage={'How to use'}
                />
              </p>
              <Row gutter={16} style={{width:1040, margin: 'auto'}} className="main-block-wapper">
              {
                [1,2,3,4].map( idx =>
                  <Col span={6} key={idx} style={{padding:0}}>
                    <div className="main-howtouse-box" style={{borderRight : idx === 4 ? 'none' : '1px solid #ddd'}}>
                      <img src={require(`../img/home/howtouse_img_0${idx}.svg`).default} alt={`how to use icon ${idx}`}/>
                      <p className="main-howtouse-title"><FormattedMessage id={`Home.howToUse.0${idx}`}/></p>
                      <p className="main-howtouse-explain"><FormattedHTMLMessage id={`Home.howToUse.0${idx}.explain`}/></p>
                    </div>
                  </Col>
                )
              }
              </Row>
              <div className="main-button-wapper">
                <Link to="/signup" className="main-button-style" onClick={()=> window.scrollTo(0, 0)}>
                  <FormattedMessage
                    id={'Home.button.signup'}
                    defaultMessage={'Join stickerfarm'}
                  />
                </Link>
                <Link to="/guide" className="main-button-style" onClick={()=> window.scrollTo(0, 0)}>
                  <FormattedMessage
                    id={'Home.button.guideline'}
                    defaultMessage={'stickerfarm Guideline'}
                  />
                </Link>
              </div>
            </div>
          { /* how to use end */ }
          { /* Featured sticker start */ }
            <div style={{minWidth:'1200px'}}>
              <p className="main-subtitle">
                <FormattedMessage
                  id={'Home.featured.title'}
                  defaultMessage={'Featured Stickers'}
                />
              </p>
              <div className="main-card-container">
                <Tabs type="card">
                {
                  ['popular', 'rising'].map((featured, idx) => {
                    const list = featured === 'popular' ? this.state.popularList : this.state.risingList;
                    return (
                      <TabPane tab={ featured === 'popular' ? 'Popular🏅' : 'Rising✨' } key={idx + 1}>
                        <Carousel className="featured-carousel">
                          {
                            list ? list.map((result, index) =>
                                <div key={index}>
                                  <FeaturedSticker
                                    cartonData={result.cartonInfoObj}
                                    stickerListData={result.stickerUrlArray}
                                    credit={result.credit}
                                    featuredDate={result.featuredDate}
                                    createdAt={result.createdAt}
                                    />
                                </div>
                              ) : null
                          }
                        </Carousel>
                      </TabPane>
                    );
                  })
                }
                </Tabs>
              </div>
            </div>
          { /* Featured sticker end */ }
          { /* mojitok appstore start */ }
            <div style={{backgroundColor: '#a202ff'}}>
              <div className="main-mojitok-introduce">
                <div className="main-mojitok-container">
                  <div style={{display:'flex', justifyContent: 'flex-end'}}>
                    <img src={require('../img/home/logo_mojitok.svg').default} alt=""/>
                  </div>
                  <p className="main-mojitok-explain" style={{display:'flex', justifyContent: 'flex-end'}}>
                    <FormattedHTMLMessage
                      id={'Home.mojitok.explain'}
                      defaultMessage={'Chill chats with dope stickers<br/> Send it and express your emotion'}
                      />
                  </p>
                  <div>
                  <a href="https://itunes.apple.com/us/app/mojitok-stickers/id1401180608?l=ko&ls=1&mt=8" target="_blank" rel="noopener noreferrer" >
                    <img src={require('../img/icon_app_store.svg').default} alt=""/>
                  </a>
                  <a href="https://play.google.com/store/apps/details?id=com.mojitok.app" target="_blank" rel="noopener noreferrer" >
                    <img src={require('../img/icon_google_play.png').default} alt="" style={{height: 50, marginLeft: 8}} />
                  </a>
                  <img src={require('../img/home/icon_galaxy@2x.png').default} alt="" style={{height: 50, marginLeft: 8}}/>
                  </div>
                </div>
              </div>
            </div>
          { /* mojitok appstore end */ }
          { /* fack footer start */ }
            <div style={{ margin:'30px auto', width:'1040px'}}>
              <span className="main-fack-footer-left">
                <div className="main-fack-footer-left-line" style={{marginBottom:20}}>
                  <Icon type="shop" className="main-fack-footer-left-icon"/>&nbsp;&nbsp;<b>Address</b> &nbsp;&nbsp;&nbsp;&nbsp; 4F 105 Office, 147, Yanghwa-ro, Mapo-gu, Seoul, Korea (03995)<br/>
                </div>
                <div className="main-fack-footer-left-line">
                  <Icon type="mail" className="main-fack-footer-left-icon"/>&nbsp;&nbsp;<b>Contact</b> &nbsp;&nbsp;&nbsp;&nbsp; mojitok@platfarm.net
                </div>
              </span>
              <span className="main-fack-footer-right">
                <a href="https://pf.kakao.com/_YqZxfK" target="_blank" rel="noopener noreferrer" >
                  <img src={require('../img/home/linkIcon/kakao_channel_icon.png').default} alt=""
                    onMouseOver={ e => e.currentTarget.src=require('../img/home/linkIcon/kakao_channel_icon_02.png').default }
                    onMouseOut={ e => e.currentTarget.src=require('../img/home/linkIcon/kakao_channel_icon.png').default }
                  />
                </a>
                <a href="https://blog.naver.com/PostList.nhn?blogId=mojitok&from=postList&categoryNo=9" target="_blank" rel="noopener noreferrer" alt="naver-blog">
                  <img src={require('../img/home/linkIcon/naver_blog_icon.png').default} alt=""
                    onMouseOver={ e => e.currentTarget.src=require('../img/home/linkIcon/naver_blog_icon_02.png').default }
                    onMouseOut={ e => e.currentTarget.src=require('../img/home/linkIcon/naver_blog_icon.png').default }
                  />
                </a>
                <a href="https://www.instagram.com/stickerfarm_mojitok" target="_blank" rel="noopener noreferrer">
                  <img src={require('../img/home/linkIcon/insta_icon.png').default} alt=""
                    onMouseOver={ e => e.currentTarget.src=require('../img/home/linkIcon/insta_icon_02.png').default }
                    onMouseOut={ e => e.currentTarget.src=require('../img/home/linkIcon/insta_icon.png').default }
                  />
                </a>
                <a href="https://www.facebook.com/withMojitok" target="_blank" rel="noopener noreferrer">
                  <img src={require('../img/home/linkIcon/facebook_icon.png').default} alt=""
                    onMouseOver={ e => e.currentTarget.src=require('../img/home/linkIcon/facebook_icon_02.png').default }
                    onMouseOut={ e => e.currentTarget.src=require('../img/home/linkIcon/facebook_icon.png').default }
                  />
                </a>
              </span>
            </div>
          { /* fack footer end */ }
          </Content>
          <Footer className="footer-wapper">
            <div className="footer">
            {
              this.props.language==='en'?
              <span>
                <span className="footer-contents" style={{paddingLeft:0}}>
                  <a href={require("../img/file/TERMSANDCONDITIONS_en.docx").default} download>Terms and Conditions</a>
                </span> |
                <span className="footer-contents">
                  <a href={require("../img/file/PRIVACYPOLICY_en.docx").default} download>Privacy statement</a>
                </span>
              </span> :
              <span>
                <span className="footer-contents" style={{paddingLeft:0}}>
                  <a href={require("../img/file/TERMSANDCONDITIONS_ko.docx").default} download>Terms and Conditions</a>
                </span> |
                <span className="footer-contents">
                  <a href={require("../img/file/PRIVACYPOLICY_ko.docx").default} download>Privacy statement</a>
                </span>
              </span>
             }  |
              <span className="footer-contents">
                <Link to="/faq">FAQ</Link>
              </span> |
              <span className="footer-contents">
                <a href="mailto:mojitok@platfarm.net">Contact</a>
              </span>
              <span className="footer-copyright">
                <b>Copyright</b> © {new Date().getFullYear()} Platfarm Inc. All rights reserved.
              </span>
            </div>
          </Footer>
        </Layout>
      )
    }



}//end Home class

//featuredtype에 따라 스티커를 구하는 함수
function getFeaturedStickers(featuredType){
  return new Parse.Query(Parse.Object.extend('Stickerfarm_Featured'))
    .equalTo('featuredType', featuredType)
    .descending('createdAt') //최근 생성된 순으로
    .limit(4)
    .find()
    .then(featureds =>
      featureds.map(featured => {
        return {
          cartonInfoObj:featured.get('featuredInfoUrl').carton,
          stickerUrlArray:featured.get('featuredInfoUrl').stickerURL,
          credit:featured.get('credit'),
          featuredDate:featured.get('featuredDate'),
          createdAt: featured.createdAt
        };
      })

    ).catch(error => console.log(error));

}

  
Home = injectIntl(Home);

export default Home;
